import { createGlobalStyle } from 'styled-components';
import { BREAKPOINTS } from '../../app/appConstants';

/**
 * Modals — use contentClassName="app-form-modal" for form dialogs
 * (aliases: admin-form-modal, partner-form-modal).
 */
export const GlobalModalStyled = createGlobalStyle`
    @media (min-width: ${BREAKPOINTS.small}px) {
        .modal-lg,
        .modal-xl {
            max-width: 800px;
        }
    }

    @media (min-width: ${BREAKPOINTS.large}px) {
        .modal-xl {
            max-width: 1140px;
        }
    }

    .modal-fullscreen {
        .modal-header {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 10;
        }

        .modal-content {
            padding-top: 64px;
        }
    }

    .modal-content {
        background: var(--app-bg-modal-color);
        border: 1px solid var(--color-main);
        border-radius: var(--radius-lg);
        overflow: hidden;
        color: var(--color-white-95);
    }

    .modal-header {
        display: flex;
        align-items: center;
        padding: 18px 20px 14px;
        background: var(--color-surface-secondary);
        border-bottom: 1px solid var(--color-main);
    }

    .modal-title {
        margin: 0;
        font-size: var(--font-size-lg);
        font-weight: 600;
        line-height: 1.3;
        color: var(--color-white-95);
    }

    .modal-body {
        padding: var(--space-5);
    }

    .modal-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: var(--space-2);
        padding: 14px 20px;
        background: var(--color-surface-secondary);
        border-top: 1px solid var(--color-main);
    }

    .btn-close {
        opacity: 0.8;
        background: transparent url("/assets/icons/ic_x_mark.svg") center/1em auto no-repeat;
        box-shadow: none;

        &:hover {
            opacity: 1;
        }
    }

    .modal-content.app-form-modal,
    .modal-content.admin-form-modal,
    .modal-content.partner-form-modal,
    .modal-content.partner-balance-modal {
        background: var(--color-surface);
    }

    .modal-content.app-form-modal .modal-header,
    .modal-content.admin-form-modal .modal-header,
    .modal-content.partner-form-modal .modal-header,
    .modal-content.partner-balance-modal .modal-header {
        padding: 18px 20px 14px;
        background: var(--color-surface-secondary);
        border-bottom: 1px solid var(--color-main);
    }

    .modal-content.app-form-modal .modal-body,
    .modal-content.admin-form-modal .modal-body,
    .modal-content.partner-form-modal .modal-body,
    .modal-content.partner-balance-modal .modal-body {
        padding: var(--space-5);
    }

    .modal-content.app-form-modal .modal-footer,
    .modal-content.admin-form-modal .modal-footer,
    .modal-content.partner-form-modal .modal-footer,
    .modal-content.partner-balance-modal .modal-footer {
        padding: 14px 20px;
        background: var(--color-surface-secondary);
        border-top: 1px solid var(--color-main);
        gap: var(--space-2);
    }
`;
